import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  className?: string;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 6,
  columns = 4,
  className = '',
}) => {
  return (
    <div className={`aa-skeleton-table ${className}`} aria-hidden="true">
      <div className="aa-skeleton-table-head">
        {Array.from({ length: columns }).map((_, index) => (
          <SkeletonBlock key={index} height={12} />
        ))}
      </div>
      <div className="aa-skeleton-table-body">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div className="aa-skeleton-table-row" key={rowIndex}>
            {Array.from({ length: columns }).map((__, colIndex) => (
              <SkeletonBlock key={colIndex} height={10} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
